import apiRequest from '../apis/api-request';
import { selectAuthToken } from '../redux/reducers/authReducers';
import { store } from '../redux/store';

const vesselService = {

    getVessel: async (data) => {
        const token = selectAuthToken(store.getState())
        const search = data.search ? data.search : ''
        const size = data.size ? data.size : 25
        const page = data.page ? data.page : 0
        return apiRequest({
            method: "GET",
            url: `/api/vessel?search=${search}&size=${size}&page=${page}`,
            headers: {
                Authorization: "Bearer " + token
            },
        });
    },
    
    createVessel: async (data) => {
        const token = selectAuthToken(store.getState())
        return apiRequest({
            method: "POST",
            url: `/api/vessel`,
            data: data,
            headers: {
                Authorization: "Bearer " + token
            },
        });
    },
    
    updateVessel: async (data) => {
        const token = selectAuthToken(store.getState())
        return apiRequest({
            method: "PUT",
            url: `/api/vessel`,
            data: data,
            headers: {
                Authorization: "Bearer " + token
            },
        });
    },

    deleteVessel: async (id) => {
        const token = selectAuthToken(store.getState());
        return apiRequest({
            method: "DELETE",
            url: `/api/vessel/${id}`,
            headers: {
                Authorization: "Bearer " + token
            },
        });
    }

};

export default vesselService;